import React from "react";
import PropTypes from "prop-types";

import "./AppLoading.style.scss";

function AppLoading(props) {
  return (
    <div className="appLoader">
      <img width={260} src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" />
    </div>
  );
}

AppLoading.propTypes = {};

export default AppLoading;
